const getters = {

  isClubLoggedIn: state => !!state.Clubtoken,
  isLoading: state => state.loading,
  authStatus: state => state.status,
  club: state => state.club,
  isClubToken: state => state.Clubtoken,
  isClubName: (state) => {
    if (state.club === null) {
      return "";
    }
    const ClubName = state.club.name;
    return ClubName;
  },
  isClubID: (state) => {
    if (state.club === null) {
      return "";
    }
    const ClubID = state.club.id;
    return ClubID;
  },
  GET_CLUBMENU: (state, getters) => {
    if (!state.clubmenu) return null;

    const can = getters.clubCan;

    return state.clubmenu.map(group => {
      if (group.title === 'Arbeitsstunden') {
        const entries = group.entry.filter(entry => {
          if (entry.route === '/club/workinghours' || entry.route === '/club/arbeitsstunden') {
            return can.arbeitsstunden;
          }
          if (entry.route === '/club/arbeitsstunden/freigaben') {
            return can.arbeitsstunden;
          }
          if (entry.route === '/club/arbeitsstunden/funktionen') {
            return can.arbeitsstunden;
          }
          if (entry.route === '/club/arbeitsstunden/auswertung') {
            return can.arbeitsstunden_full;
          }
          if (entry.route === '/club/arbeitseinsaetze' || entry.route === '/club/arbeitsstunden/arbeitseinsaetze') {
            return can.arbeitsstunden_full;
          }
          if (entry.route === '/club/beitragsgruppen' || entry.route === '/club/arbeitsstunden/beitragsgruppen') {
            return can.arbeitsstunden_full;
          }
          return true;
        }).map(entry => {
          // Pfade anpassen falls sie noch auf die alten Routen zeigen
          let newRoute = entry.route;
          if (entry.route === '/club/workinghours') newRoute = '/club/arbeitsstunden';
          if (entry.route === '/club/arbeitseinsaetze') newRoute = '/club/arbeitsstunden/arbeitseinsaetze';
          if (entry.route === '/club/beitragsgruppen') newRoute = '/club/arbeitsstunden/beitragsgruppen';

          return { ...entry, route: newRoute };
        });

        return { ...group, entry: entries };
      }
      return group;
    });
  },
  can_RFID: (state) => {
    if (state.club === null) {
      return false;
    }
    return state.club.can_rfid === 1;
  },
  clubCan: (state) => {
    // Falls keine Club-Daten da sind, blockieren wir (Sicherheit)
    if (!state.club) {
      return {
        rfid: false,
        glt: false,
        weapon_pool: false,
        arbeitsstunden: false,
        arbeitsstunden_full: false
      };
    }

    // 1. Check auf explizites 'can'-Objekt (Briefing-Standard)
    if (state.club.can) {
      return state.club.can;
    }

    // 2. Fallback auf 'roles'-Array (wie im JSON-Beispiel geliefert)
    const roles = Array.isArray(state.club.roles)
      ? state.club.roles.map(r => (typeof r === 'object' ? r.name : r))
      : [];

    return {
      rfid: roles.includes('club_terminal_rfid') || state.club.can_rfid === 1,
      glt: roles.includes('club_can_glt') || state.club.can_glt === 1,
      weapon_pool: roles.includes('Club Weapon Pool') || (state.club.permissions && state.club.permissions.some(p => p.name === 'UseWeaponPool')),
      arbeitsstunden: roles.includes('can_arbeitsstunden'),
      arbeitsstunden_full: roles.includes('can_arbeitsstunden_full')
    };
  }
};

export default getters;
